import React from "react";
import { useTranslation } from "react-i18next";
import { Users, ChevronRight } from "lucide-react";

const capitalizeWords = (str) =>
  str
    ?.split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ") || "";

const TeamRow = ({ team, isLast = false, onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}
      className={`flex cursor-pointer items-center justify-between px-4 py-3 transition duration-150 hover:bg-[#FAFAFA] ${
        !isLast ? "border-b border-[#F3F4F6]" : ""
      }`}
    >
      {/* Left side */}
      <div className="flex items-center gap-3">
        {/* Team icon */}
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#F3F4F6]">
          <Users size={16} className="text-[#6B7280]" />
        </div>

        {/* Team info */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-[#111827]">
            {team.name}
          </span>

          {/* Sport badge */}
          <span className="rounded bg-[#E0F2F1] px-1.5 py-0.5 text-[10px] font-medium text-[#00796B]">
            {capitalizeWords(team.sport)}
          </span>

          {/* Live badge */}
          {team.isLive && (
            <span className="flex items-center gap-1 rounded bg-[#DCFCE7] px-1.5 py-0.5 text-[10px] font-medium text-[#16A34A]">
              <span className="relative flex h-1 w-1">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#16A34A] opacity-75"></span>
                <span className="relative inline-flex h-1 w-1 rounded-full bg-[#16A34A]"></span>
              </span>
              {t("common.status.live")}
            </span>
          )}
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-4">
        <span className="text-xs text-[#6B7280]">
          {t("workspace.overview.teamRow.counts", {
            players: team.playerCount,
            sessions: team.sessionCount,
          })}
        </span>

        {/* Chevron */}
        <ChevronRight size={16} className="text-[#D1D5DB]" />
      </div>
    </div>
  );
};

export default TeamRow;
